export default __webpack_public_path__ + "static/media/cross-color.7b0ca01c.svg";